export const NAMESPACE = 'giftie_settings'
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024 // 10MB
export const MAX_FILE_SIZE_MB = 10
export const MAX_GREETING_CARD_DESIGN_FILE_SIZE_BYTES = 5 * 1024 * 1024 // 5MB
export const MAX_GREETING_CARD_DESIGN_FILE_SIZE_MB = 5
export const RECOMMENDED_GREETING_CARD_DESIGN_FILE_SIZE_MB = 1
export const RECOMMENDED_GREETING_CARD_DESIGN_DPI = 300
export const MIN_GREETING_CARD_DESIGN_DPI = 150
